import { Observable } from 'rxjs';

/** First value of the request; an abort unsubscribes (cancelling the HTTP call) and rejects with an AbortError. */
export function abortableRequest<T>(
  request$: Observable<T>,
  abortSignal?: AbortSignal
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    if (abortSignal?.aborted) {
      reject(abortError());
      return;
    }
    const onAbort = () => {
      subscription.unsubscribe();
      reject(abortError());
    };
    const subscription = request$.subscribe({
      next: (value) => {
        abortSignal?.removeEventListener('abort', onAbort);
        subscription.unsubscribe();
        resolve(value);
      },
      error: (error) => {
        abortSignal?.removeEventListener('abort', onAbort);
        reject(error);
      },
    });
    abortSignal?.addEventListener('abort', onAbort, { once: true });
  });
}

export function isAbortError(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}

function abortError(): DOMException {
  return new DOMException('Request aborted', 'AbortError');
}
